import React, { memo } from 'react';

import { ICountryDetail } from '@webtrader/core/api/account/country';
import { EDataTestId } from '@webtrader/core/constants/test';
import { setCountryKeyString } from '@webtrader/core/format/country';

import ActionSheetCheckmark from '@/components/ActionSheet/Checkmark';

import {
  StyledDropdownSelectorContainer,
  StyledDropdownSelectorIcon,
  StyledDropdownSelectorText
} from '../../screens/auth/DemoCreation/styled';

interface ICountrySelectorProps {
  country: ICountryDetail;
  selected?: boolean;
  onSelect: (country: string) => void;
}

const CountrySelector: FCC<ICountrySelectorProps> = (props) => {
  const { country, selected, onSelect } = props;
  const { country: countryName, dialCode, countryCode } = country;
  const label = countryCode ? `${countryName} - ${countryCode} (${dialCode})` : `${countryName} (${dialCode})`;

  const onSelectCountry = () => onSelect(setCountryKeyString(country));

  return (
    <StyledDropdownSelectorContainer
      selected={selected}
      activeOpacity={1}
      onPress={onSelectCountry}
      testID={EDataTestId.COUNTRY_DIAL_CODE_ITEM}
      accessibilityState={{ selected }}
      accessibilityLabel={countryName}
    >
      <StyledDropdownSelectorText>{label}</StyledDropdownSelectorText>
      <StyledDropdownSelectorIcon>{selected && <ActionSheetCheckmark />}</StyledDropdownSelectorIcon>
    </StyledDropdownSelectorContainer>
  );
};

export default memo(CountrySelector);
